module.exports = __webpack_public_path__ + "assets/img/ic-cash-remittance.fcbce801.svg";